import script from "./ItensList.vue?vue&type=script&setup=true&lang=js"
export * from "./ItensList.vue?vue&type=script&setup=true&lang=js"

import "./ItensList.vue?vue&type=style&index=0&id=faaf6a46&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faaf6a46"]])

export default __exports__